import { render, staticRenderFns } from "./checkTicket.vue?vue&type=template&id=553c52b7&scoped=true&"
import script from "./checkTicket.vue?vue&type=script&lang=js&"
export * from "./checkTicket.vue?vue&type=script&lang=js&"
import style0 from "./checkTicket.vue?vue&type=style&index=0&id=553c52b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c52b7",
  null
  
)

export default component.exports